import React, { useEffect } from 'react'
import Navigation from '../components/Navigation'
import posthog from '../utils/posthog.js'

const successIcon = '/icon/checkmark-circle-03.svg'
const redirectUrl = 'https://console.notifyer-systems.com/sign-in'

const ThankYou = () => {
  useEffect(() => {
    const email = localStorage.getItem('notifyer_user_email')
    if (email) {
      posthog.identify(email, { email })
    }
    posthog.capture('thank_you_page_viewed')
  }, [])

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-white via-[#f6fbf8] to-[#e0fbe9] text-[#1c2329]">
      {/* Subtle dotted overlay */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, rgba(28,35,41,0.08) 1px, transparent 0)',
          backgroundSize: '22px 22px',
          opacity: 0.5,
        }}
        aria-hidden="true"
      />
      {/* Soft glow accents */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_18%_25%,rgba(0,200,107,0.18),transparent_36%),radial-gradient(circle_at_80%_75%,rgba(14,165,233,0.15),transparent_42%)]" />

      <Navigation />

      <main className="relative mx-auto grid max-w-4xl place-items-center px-4 pb-12 pt-10 text-center sm:px-6 sm:pt-12 sm:pb-14 lg:px-8">
        <div className="mx-auto w-full overflow-hidden rounded-[18px] border border-[#e3eee8] bg-white/85 shadow-[0px_18px_60px_rgba(0,172,111,0.12)] backdrop-blur">
          <div className="grid place-items-center gap-5 px-4.5 py-7 sm:gap-6 sm:px-7 sm:py-8 lg:px-8">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#e3eee8] bg-white/80 px-3.5 py-1.5 text-[12px] font-semibold uppercase tracking-[0.35px] text-[#00c86b] shadow-[0px_6px_18px_rgba(15,25,34,0.08)] sm:px-4 sm:text-[12.5px]">
              <div className="grid h-8 w-8 place-items-center rounded-full bg-[#00c86b]/10">
                <img src={successIcon} alt="Success" className="h-5 w-5" />
              </div>
              <span className="whitespace-nowrap">Free trial activated</span>
            </div>

            <div className="space-y-3 px-1 sm:px-0">
              <h1 className="text-[26px] font-semibold leading-[1.08] tracking-[-0.9px] text-[#0f1922] sm:text-[30px] lg:text-[34px]">
                Welcome to Notifyer — your console is ready
              </h1>
              <p className="mx-auto max-w-3xl text-[15px] leading-[1.65] tracking-[-0.26px] text-[#4b5650] sm:text-[15.5px]">
                Hop into the console to connect WhatsApp, and launch your first on-brand workflow in minutes.
              </p>
            </div>

            {/* Email credentials callout */}
            <div className="flex w-full max-w-md flex-col items-center gap-3 rounded-2xl border-2 border-[#00c86b]/30 bg-gradient-to-br from-[#00c86b]/08 via-[#00c86b]/05 to-transparent px-5 py-4 shadow-[0px_8px_24px_rgba(0,200,107,0.12)] sm:flex-row sm:gap-4 sm:px-6 sm:py-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#00c86b]/15 text-[#00ac6f]">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <div className="text-center sm:text-left">
                <p className="text-[15px] font-semibold leading-snug tracking-[-0.3px] text-[#0f1922]">
                  Check your email for login credentials
                </p>
                <p className="mt-1 text-[13px] leading-[1.5] text-[#4b5650]">
                  We&apos;ve sent your sign-in details to your inbox. If you don&apos;t see it, check your spam or junk folder.
                </p>
              </div>
            </div>

            <div className="flex w-full justify-center pt-1">
              <button
                onClick={() => {
                  posthog.capture('console_redirect_clicked')
                  window.location.assign(redirectUrl)
                }}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0f1922] px-8 py-4 text-[15px] font-semibold tracking-[-0.4px] text-white shadow-[0px_10px_28px_rgba(15,25,34,0.25)] transition hover:-translate-y-0.5 hover:bg-[#0b131a] hover:shadow-[0px_14px_32px_rgba(15,25,34,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0f1922] focus-visible:ring-offset-2 focus-visible:ring-offset-white min-w-[240px]"
              >
                Continue with setup
                <span aria-hidden="true" className="text-[18px] leading-none">
                  ↗
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default ThankYou
